import { render, staticRenderFns } from "./AddNewTee.vue?vue&type=template&id=58d60088"
import script from "./AddNewTee.js?vue&type=script&lang=js&external"
export * from "./AddNewTee.js?vue&type=script&lang=js&external"
import style0 from "./AddNewTee.vue?vue&type=style&index=0&id=58d60088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports